import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { BRAND, CONTACT } from '../lib/butterstone';

const LINKS = [
  { label: 'Gallery', href: '#gallery' },
  { label: 'Activities', href: '#activities' },
  { label: 'Stay', href: '#stay' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'About', href: '#about' },
  { label: 'Nearby', href: '#nearby' },
  { label: 'Contact', href: '#contact' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href) => { setOpen(false); const el = document.querySelector(href); if (el) el.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#F6F5EF]/95 backdrop-blur-md shadow-[0_2px_20px_rgba(30,50,38,0.08)] py-3' : 'bg-transparent py-5'}`} data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="#top" onClick={(e)=>{e.preventDefault();window.scrollTo({top:0,behavior:'smooth'});}} className="flex flex-col leading-none">
          <span className={`font-serif text-xl md:text-2xl tracking-tight ${scrolled ? 'text-[#1E3226]' : 'text-white'}`}>{BRAND.name}</span>
          <span className={`text-[9px] md:text-[10px] tracking-[0.28em] uppercase mt-1 ${scrolled ? 'text-[#5E6E60]' : 'text-white/75'}`}>{BRAND.group}</span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map(l => (
            <button key={l.href} onClick={() => go(l.href)} className={`link-underline text-[13px] tracking-wide font-medium transition-colors ${scrolled ? 'text-[#2F5233] hover:text-[#1E3226]' : 'text-white/90 hover:text-white'}`} data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </button>
          ))}
          <a href={`tel:+91${CONTACT.phone1}`} className={`flex items-center gap-2 text-[13px] font-semibold ${scrolled ? 'text-[#2F5233]' : 'text-white'}`}><Phone size={15} /> {CONTACT.phone1Display}</a>
        </nav>

        <button className="lg:hidden" onClick={() => setOpen(true)} aria-label="Open menu" data-testid="mobile-menu-open">
          <Menu className={scrolled ? 'text-[#1E3226]' : 'text-white'} size={26} />
        </button>
      </div>

      <div className={`mobile-menu lg:hidden ${open ? 'open' : ''}`}>
        <div className="flex items-center justify-between px-6 py-6">
          <span className="font-serif text-2xl text-white">{BRAND.shortName}</span>
          <button onClick={() => setOpen(false)} aria-label="Close menu" data-testid="mobile-menu-close"><X className="text-white" size={28} /></button>
        </div>
        <nav className="flex flex-col px-6 mt-6 gap-1">
          {LINKS.map((l, i) => (
            <button key={l.href} onClick={() => go(l.href)} className="text-left font-serif text-3xl text-white/90 py-3 border-b border-white/10">
              <span className="text-[11px] font-sans text-[#6E9A5E] mr-3 align-middle">0{i+1}</span>{l.label}
            </button>
          ))}
        </nav>
        <div className="px-6 mt-8 space-y-2 text-white/80">
          <a href={`tel:+91${CONTACT.phone1}`} className="flex items-center gap-2"><Phone size={16} /> {CONTACT.phone1Display}</a>
          <a href={`tel:+91${CONTACT.phone2}`} className="flex items-center gap-2"><Phone size={16} /> {CONTACT.phone2Display}</a>
        </div>
      </div>
    </header>
  );
};

export default Header;
